// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_25d45facb5--wrapper--LQPOO","static":"_25d45facb5--static--KWF5p","inner":"_25d45facb5--inner--R_2xj"};